import React from "react";
import ReactDOM from "react-dom/client";
import "styles/index.css";
import "styles/design-system.css";
import App from "./App";
import ReactGA from "react-ga4";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";
import * as Sentry from "@sentry/react";
import sentryConfig from "./config/sentry";
import store from "./state/store";
import Cookies from "universal-cookie";
import mixpanel from "mixpanel-browser";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <BrowserRouter>
    <Provider store={store}>
      <App />
    </Provider>
  </BrowserRouter>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

const setOrganizationDomain = () => {
  const cookies = new Cookies();

  const domain = window.location.hostname;
  const parts = domain.split(".");
  // Extract all subdomain parts (everything except the last 2: domain and TLD)
  // For 'colombia.drrobert.neuroelpis.com' -> ['colombia', 'drrobert']
  // For 'drrobert.neuroelpis.com' -> ['drrobert']
  // For domains with < 3 parts (e.g., 'localhost'), use the first part or fallback
  let subDomain = parts.length >= 3
    ? parts.slice(0, -2).join(".")
    : parts[0] || domain;

  if (subDomain === "localhost" || subDomain === "uat") {
    subDomain = "uat";
  }
  cookies.set("organization", subDomain, { path: "/" });
};

// Immediately Invoked Function Expression
(() => {
  // Initialize Google ReCaptcha
  ReactGA.initialize(process.env.REACT_APP_G_TAG_ID);

  // Initialize Mixpanel
  const mixpanelToken = process.env.REACT_APP_MIXPANEL_TOKEN;
  if (mixpanelToken) {
    mixpanel.init(mixpanelToken, {
      debug: true,
      track_pageview: true,
      persistence: 'localStorage'
    });
  } else {
    console.warn('REACT_APP_MIXPANEL_TOKEN not found. Mixpanel will not be initialized.');
  }


  // Read and set organization domain
  setOrganizationDomain();

  // Initialize Sentry
  // Sentry.init(sentryConfig);

  // Disable logs if enviroment is not development
  if (process.env.NODE_ENV !== "development") console.log = () => { };
})();
